import './app.js'
import CamperAbstract from './camper-abstract.js'
import CamperForm from './camper-form.js'
import { appearOnIntersect } from './observer-appear.js'
import { loadStyle, loadScript } from './helpers.js'

const carousel = document.querySelector( 'section.carousel' )
window.addEventListener( 'resize', () => {
  const { clientWidth: width } = carousel

  carousel.style.height = Math.round( width / 3.048 ) + 'px'
})
window.dispatchEvent( new Event( 'resize' ) )

//init abstracts
CamperAbstract.init()

//init abstracts
CamperForm.init()

//appear on intersect and load images
appearOnIntersect()

//swiper delayed load
setTimeout( () => {
  loadStyle( '/css/home-carousel.css', { callback: () => loadScript( '/js/home-carousel.js' ) } )
}, process.env.MIX_LIB_3RD_DELAY )
